import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginService, Roles } from 'src/app/api/authentication';
import { Associate } from 'src/app/api/authentication/associate';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  notAuthorized = false;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.createLoginForm();
  }

  createLoginForm() {
    this.loginForm = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', Validators.required],
    })
  }

  login() {
    if (this.loginForm.valid) {
      this.loginService.login(this.loginForm.value).subscribe((user) => {
        if (user.user.role.name == Roles.ADMIN) {
          this.router.navigate(['/admin'])
        } else if (user.user.role.name == Roles.USER) {
          this.router.navigate(['/user'])
        } else if (user.user.role.name == Roles.ASSOCIATE && user.user.associate.type == Associate.CHURCH) {
          void this.router.navigate(['/igreja'])
        } else if (user.user.role.name == Roles.ASSOCIATE && user.user.associate.type == Associate.COMMERCE) {
          void this.router.navigate(['/comercio'])
        } else if (user.user.role.name == Roles.ASSOCIATE && user.user.associate.type == Associate.MISSIONARY) {
          void this.router.navigate(['/missionario'])
        } else if (user.user.role.name == Roles.ASSOCIATE && user.user.associate.type == Associate.SERVICEPROVIDER) {
          void this.router.navigate(['/servico'])
        } else if (user.user.role.name == Roles.ASSOCIATE && user.user.associate.type == Associate.MUSICALARTIST) {
          void this.router.navigate(['/banda-cantor'])
        }
      }, error => {
        this.notAuthorized = true;
        this.loginForm.reset()
        this.toastr.error('Usuário e/ou senha incorreto(s)!')
      })
    } else {
      this.loginForm.markAllAsTouched()
      this.toastr.error('Preencha os campos inválidos !')
    }
  }
}
